import React, { useEffect, useState } from 'react'
import { useNavigate } from "react-router-dom"

import { Row, Col, Card, Nav, Tab } from 'react-bootstrap'
import trophy from '../../assets/trophy1.png'
import CompleteMatchBg from '../../assets/images/complete-match-bg.png'
import Melbourne_Knight from '../../assets/images/teams/Melbourne_Knight.png'
import Sydney_thunder from '../../assets/images/teams/Sydney_thunder.png'
import Calander from '../../components/icons/calander'
import Location from '../../components/icons/location'
import Clock from '../../components/icons/Clock'
import '../../assets/css/Player/LatestMatch.css'
import { FormatDate, getTime, newFormatdate, format_2k_run_Time_exact } from '../../Common/CommonFunction'
import cardBg from '../../assets/images/complete-match-bg.png'
import notFound from '../../assets/images/avatars/notfound1.png'
import golden from '../../assets/images/games/bronzer.svg'
import silver from '../../assets/images/games/silver.svg'
import bronze from '../../assets/images/games/golden.svg'
import Waiting from '../../assets/images/waiting.jpg'
import Enrolled from '../../assets/images/enrolled.png'
import badw from '../../assets/images/badmintion-w.jpg';
import ttw from '../../assets/images/table-tennis-w.jpg';
import boww from '../../assets/images/bowling-w.jpg';
import twokw from '../../assets/images/twok_w.jpg'
import { getSetting, FilterDynamicText } from '../../API/admin';
import { ExitWaitList } from '../../API/player';

import Swal from "sweetalert2";
import { useSnackbar } from 'notistack';

import { CCard, CCardBody, CCol, CRow } from '@coreui/react'

const LatestMatch = ({ latestMatch, gameType, gametypes, waitListGame, enrolledSport, TournamentID }) => {
  let navigate = useNavigate();
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const allWaitListFalse = Object.values(waitListGame).every(value => value === false);
  const allEnrolledSportFalse = Object.values(enrolledSport).every(value => value === false);

  console.log(" allWaitListFalse", TournamentID);
  console.log(" allEnrolledSportFalse", enrolledSport);

  const [game, setGame] = useState(null);
  // const [dynamicHeading, setdynamicHeading] = useState(null);
  const [dynamicHeading, setDynamicHeading] = useState({});

  const [Joinbutton, setJoiButton] = useState(false);
  const [TournamentOff, setTournamentOff] = useState(false);


  useEffect(() => {
    const handelJoin = async () => {
      let res = await getSetting();

      if (res.status) {

        res.data.forEach((entry) => {
          if (game === 'Badminton' && enrolledSport.badminton == false || game === 'TableTennis' && enrolledSport.table_tenis == false || game === 'bowling' && enrolledSport.bowling == false || game === '2k_run' && enrolledSport.twok_run == false) {
            console.log("in true");
            if (entry.value === "false" && entry.name === 'tournament_register') {
              setJoiButton(false);
              setTournamentOff(true);
              // Swal.fire({
              //   title: dynamicHeading.registration_closed
              //   ? dynamicHeading.registration_closed.title ? dynamicHeading.registration_closed.title
              //   : 'Tournament registration are closed':   'Tournament registration are closed',
              // text: dynamicHeading.registration_closed
              //   ? dynamicHeading.registration_closed.value
              //   : 'You are late, tournament registration is closed, try again next time.',
              //   icon: "error",
              //   allowOutsideClick: false,
              //   allowEscapeKey: false
              // })
            } else if (entry.value === "true" && entry.name === 'tournament_register') {
              setJoiButton(true)
            }
          } else {
            console.log("falseeeee", game, "enr", enrolledSport.table_tenis)
          }

        });
      } else {
        enqueueSnackbar('Unable to fetch settings', {
          variant: 'error', action: (key) => (
            <button className='toast_close_btn'
              onClick={() => {
                // Close the Snackbar
                closeSnackbar(key);
              }}
            >
              X
            </button>
          ),
        });
      }
    }
    if (game != null) {

      handelJoin();
    }
  }, [game])
  useEffect(() => {
    console.log("gamme" + gametypes)
    // gameType(getGame)
    setGame(gametypes);
    let callAPI = async () => {
      let formData = {
        "data": null
      }
      let res = await FilterDynamicText(formData);
      if (res.data.status) {
        console.log(res.data.data)
        setDynamicHeading(res.data.data)
      }
    }
    callAPI()
  }, [gametypes])
  console.log(game);
  const CompleteMatchStyle = {
    // backgroundImage: 'url(' + CompleteMatchBg + ')',
    // backgroundSize: '3rem',
    // backgroundRepeat: 'no-repeat'
  }
  const getGame = () => {
    const searchParams = new URLSearchParams(window.location.search);
    let game = searchParams.get('game');
    if (!game) {
      game = 'Badminton';
    }
    return game;
  };
  function extractdomain(inputString, startChar, endChar) {
    const startIndex = inputString.indexOf(startChar);
    const endIndex = inputString.indexOf(endChar);
    if (startIndex !== -1 && endIndex !== -1 && startIndex < endIndex) {
      return inputString.substring(startIndex + 1, endIndex);
    } else {
      console.error('Start or end characters not found or in the wrong order.');
      return inputString;
    }
  }

  const formatTitle = (text) => {
    return text
      .split(" ")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(" ");
  };
  const IMAGE_URL = process.env.REACT_APP_IMAGE_MY_ENVIRONMENT_VARIABLE
  let replaceUnderscoreWithSpace = (input) => {
    if (input.includes('_')) {
      return input.replace(/_/g, ' ');
    }
    return input;
  }

  const playerScore = (players, player_id) => {
    console.log("In functionm", player_id)
    console.log(players.find(player => player._id === player_id))
    return players.find(player => player._id === player_id);

  }
  let waitListExitAPI = async () => {
    console.log('tournament', TournamentID)
    Swal.fire({
      title: "Confirm Waitlist Exit",
      text: "Are you sure you want to exit the waitlist? By exiting the waitlist, you will no longer receive notifications when slots for this sport become available.",
      showCancelButton: true,
      cancelButtonColor: "#d33",
      cancelButtonText: "Close"

      // icon: "warning",
    }).then(async (result) => {
      if (result.isConfirmed) {
        let FormData = {
          game_type: game === 'Badminton' ? 'badminton' : game === 'TableTennis' ? 'table_tenis' : game,
          type: 'waiting',
          tournament_id: TournamentID
        }
        let res = await ExitWaitList(FormData)
        if (res.data.status) {
          enqueueSnackbar('Wating List Exited Successfully', {
            variant: 'success', action: (key) => (
              <button className='toast_close_btn'
                onClick={() => {
                  // Close the Snackbar
                  closeSnackbar(key);
                }}
              >
                X
              </button>
            ),
          })
          window.location.reload()
        } else {
          enqueueSnackbar('unable to exit Wating List ', {
            variant: 'error', action: (key) => (
              <button className='toast_close_btn'
                onClick={() => {
                  // Close the Snackbar
                  closeSnackbar(key);
                }}
              >
                X
              </button>
            ),
          })
          return false
        }
      }
    });

  }

  return (
    <div className='latest_match'>
      {/* {Object.values(waitListGame).every(value => value === false)  && Object.values(enrolledSport).every(value => value === false)  && (
                <h2 className='mt-5 mb-4 fw-bold fs-4 text-center'>Latest Match</h2>
            )} */}

      {/* {allWaitListFalse && allEnrolledSportFalse && (
                <h2 className='mt-5 mb-4 fw-bold fs-4 text-center'>Latest Match</h2>
            )} */}
      {/* reverse conditionj
             */}

      {/* {
              (allWaitListFalse  || allEnrolledSportFalse == false) &&  game === 'Badminton' ?  (  
                null
              ) :  game === 'Badminton' ?       (<h2 className='mt-5 mb-4 fw-bold fs-4 text-center'>Latest Match</h2>) : null
            }
            {
              
              (allWaitListFalse  || allEnrolledSportFalse == false) &&  game === 'TableTennis' ?  (  
                null
              ) :   game === 'TableTennis' ?   (<h2 className='mt-5 mb-4 fw-bold fs-4 text-center'>Latest Match</h2>)    : null
              
            }
            {

              (allWaitListFalse  || allEnrolledSportFalse == false) &&  game === 'bowling' ?  (  
                null
              ) :    game === 'bowling' && allEnrolledSportFalse ?  (<h2 className='mt-5 mb-4 fw-bold fs-4 text-center'>Latest Match</h2>)  : null
              
            }
            {
                (allWaitListFalse  || allEnrolledSportFalse == false) &&  game === '2k_run' ?  (  
                null
              ) :   game === '2k_run' && allEnrolledSportFalse ?   (<h2 className='mt-5 mb-4 fw-bold fs-4 text-center'>Latest Match</h2>) : null
             }
              */}
      {/* {
              allWaitListFalse == false || allEnrolledSportFalse &&  game === 'TableTennis' ? null : (    <h2 className='mt-5 mb-4 fw-bold fs-4 text-center'>Latest Match</h2>
              )
             }
               {
              allWaitListFalse == false || allEnrolledSportFalse && game === 'bowling' ? null : (    <h2 className='mt-5 mb-4 fw-bold fs-4 text-center'>Latest Match</h2>
              )
             }
               {
              allWaitListFalse == false || allEnrolledSportFalse && game === '2k_run'? null : (    <h2 className='mt-5 mb-4 fw-bold fs-4 text-center'>Latest Match</h2>
              )
             } */}

      {/* {(!allWaitListFalse || !allEnrolledSportFalse) && (
    <h2 className='mt-5 mb-4 fw-bold fs-4 text-center'>Latest Match</h2>
)} */}
      {/* uncomment according to condition */}

      {
        game === 'Badminton' && enrolledSport.badminton ? <div className='mt-5 mb-3 fw-bold fs-4 latest_match_text new_all_common_heading'>Latest Match</div> : null
      }
      {
        game === 'TableTennis' && enrolledSport.table_tenis ? <div className='mt-5 mb-3 fw-bold fs-4 latest_match_text new_all_common_heading '>Latest Match</div> : null
      }
      {
        game === 'bowling' && enrolledSport.bowling ? <div className='mt-5 mb-3 fw-bold fs-4 latest_match_text new_all_common_heading'>Latest Match</div> : null
      }
      {
        game === '2k_run' && enrolledSport.twok_run ? <div className='mt-5 mb-3 fw-bold fs-4 latest_match_text new_all_common_heading'>Latest Match</div> : null
      }
      {/* {
    game === 'Badminton'  && enrolledSport.badminton ?  <h2 className='mt-5 mb-4 fw-bold fs-4 text-center'>Latest Match</h2> : game === 'TableTennis' && enrolledSport.table_tenis ? <h2 className='mt-5 mb-4 fw-bold fs-4 text-center'>Latest Match</h2>  :  game === 'bowling' && enrolledSport.bowling ?<h2 className='mt-5 mb-4 fw-bold fs-4 text-center'>Latest Match</h2> : game === '2k_run' && enrolledSport.twok_run? <h2 className='mt-5 mb-4 fw-bold fs-4 text-center'>Latest Match</h2> : null

   } */}
      {
        TournamentOff && (game === '2k_run' && enrolledSport.twok_run == false || game === 'bowling' && enrolledSport.bowling == false || game === 'TableTennis' && enrolledSport.table_tenis == false || game === 'Badminton' && enrolledSport.badminton == false) ? (<>
          <div className=" tournament_join_main justify-content-center pt-4" >
            <span className='text_join_tournament fs-4 fw-bold'>
              {/* Tournaments is off */}
              Tournament has not started
            </span>
          </div>
        </>) : (
          <>
            {latestMatch.length > 0 ? (

              game === 'Badminton' || game === 'TableTennis' ? (
                latestMatch.map((match, index) => (
                  <>
                    <Row className='mb-5'>
                      <Col>
                        <Card
                          className='rounded-4 overflow-hidden complete-nav-card border-0'
                          style={CompleteMatchStyle}
                        >
                          <Card.Body className='p-0'>
                            <Tab.Container defaultActiveKey='#upcoming'>
                              <Nav fill variant='tabs' className='border-bottom-0'>
                                <Nav.Item className='flex-none w-25'>
                                  <Nav.Link
                                    eventKey='#upcoming'
                                    className='nav-active-tab nav-link active border-0 text-white fw-bold px-5 rounde-bottom-right-1rem nav-link active myMatch'
                                  >
                                    {replaceUnderscoreWithSpace(match.round)}
                                  </Nav.Link>
                                </Nav.Item>
                                {/* <Nav.Item className="flex-none">
                                          <Nav.Link eventKey="#completed" className="bg-transparent nav-link active border-0 text-white fw-bold px-5">Melbourne Won the match  </Nav.Link>
                                      </Nav.Item> */}
                              </Nav>
                              <Tab.Content className='p-3 text-white mymatchcard'>
                                <Tab.Pane eventKey='#upcoming'>
                                  <Row className=''>
                                    {/* <Col xs={1} className='pt-4' id='trophyimg'>
                          <span>
                            {match.player_won ===
                            match.player_details[0]._id ? (
                              <img
                                className='float-end'
                                src={trophy}
                                style={{ height: '30px' }}
                              ></img>
                            ) : null}
                          </span>
                        </Col> */}
                                    <Col
                                      xs={8}
                                      className='tab-contebt-right-border'
                                      id='mymatchrow'
                                    >
                                      <div className='my-3 d-flex align-items-center'>

                                        <div className='trophy_img_latest_match'>
                                          <span className={match.player_won ===
                                            match.player_details[0]._id ? '' : 'd-none'}>
                                            <img
                                              src={trophy}
                                              style={{ height: '30px' }}
                                            ></img>

                                          </span>
                                        </div>


                                        <div
                                          style={{
                                            backgroundImage: `url(${match.player_details[0].profile_image !==
                                              undefined
                                              ? IMAGE_URL +
                                              'user/' +
                                              match.player_details[0].profile_image
                                              : null
                                              })`
                                          }}
                                          className=' scorer-img'
                                        // className="team_logo"
                                        ></div>
                                        {/* <img src={Melbourne_Knight} alt="team_logo" className="" /> */}
                                        <div className=''>
                                          <div>
                                            <div className='ms-3' style={{ fontSize: "16px" }}>
                                              {match.player_details[0].fname +
                                                ' ' +
                                                match.player_details[0].lname}
                                            </div>
                                            <p className="ms-3 user_nameafter_info_latestmatch"
                                              style={{ color: '#2ed5d5' }}>
                                              {
                                             formatTitle(extractdomain(match.player_details[0].corporate_email, '@', '.'))
                                              
                                              }
                                            </p>
                                          </div>
                                        </div>
                                        {match.player_details[0]._id != null && match.player_1_id != null && match.player_details[0]._id.toString() == match.player_1_id.toString() ? (<span className="ms-md-auto ms-sm-auto ms-auto fw-bold">{match.player_1_score}</span>) : (<span className="ms-md-auto ms-sm-auto ms-auto fw-bold">{match.player_2_score}</span>)}

                                      </div>

                                      <div className='my-4 d-flex align-items-center'>
                                        {/* <img src={Sydney_thunder} alt="team_logo" className="" /> */}
                                        <div className='trophy_img_latest_match'>
                                          <span className={match.player_won ===
                                            match.player_details[1]._id ? '' : 'd-none'}>
                                            <img
                                              src={trophy}
                                              style={{ height: '30px' }}
                                            ></img>

                                          </span>
                                        </div>

                                        <div
                                          style={{
                                            backgroundImage: `url(${match.player_details[1].profile_image !==
                                              undefined
                                              ? IMAGE_URL +
                                              'user/' +
                                              match.player_details[1].profile_image
                                              : null
                                              })`
                                          }}
                                          className='scorer-img'
                                        ></div>
                                        <div>
                                          <div className='ms-3' style={{ fontSize: "16px" }}>
                                            {match.player_details[1].fname +
                                              ' ' +
                                              match.player_details[1].lname}
                                          </div>
                                          <p className="ms-3 text-start user_nameafter_info_latestmatch"
                                            style={{ color: '#2ed5d5' }}>
                                            {
                                            formatTitle(extractdomain(match.player_details[1].corporate_email, '@', '.'))
                                            }
                                          </p>
                                        </div>

                                        {match.player_details[1]._id != null && match.player_1_id != null && match.player_details[1]._id.toString() == match.player_1_id.toString() ? (<span className="ms-md-auto ms-sm-auto ms-auto fw-bold">{match.player_1_score}</span>) : (<span className="ms-md-auto ms-sm-auto ms-auto fw-bold">{match.player_2_score}</span>)}
                                      </div>
                                    </Col>
                                    <Col
                                      xs={4}
                                      className='match_schedule d-flex flex-column justify-content-center ps-3 col-4'
                                    >
                                      <div className='d-flex align-items-center'>
                                        <div> <Calander /></div>
                                        <p className='mb-0 ' >
                                          <span className='ms-2 latest_match_date_badmintion'>
                                            {match.match_date != null ? newFormatdate(match.match_date, 0, 0, 0, 1) : 'N/A'}
                                          </span>
                                        </p>
                                      </div>
                                      <div className='d-flex align-items-center  my-3'>
                                        <Clock />
                                        <span className='ms-2'>
                                          {match.match_date != null ? newFormatdate(match.match_date, 0, 1, 0) : 'N/A'}

                                        </span>
                                      </div>
                                      <div className='d-flex align-items-center location-logo'>
                                        <Location />
                                        <span className='ms-2 ground-name'>
                                          Melbourne Sports & Aquatic Centre (MSAC)
                                        </span>
                                      </div>
                                    </Col>
                                  </Row>
                                </Tab.Pane>
                                {/* <Tab.Pane eventKey='#completed'>
                    <Row className='ps-md-5'>
                      <Col xs={1} className='pt-4'>
                        <span>
                          <img
                            className='float-end'
                            src={trophy}
                            style={{ height: '30px' }}
                          ></img>
                        </span>
                      </Col>
                      <Col
                        xs={7}
                        className='tab-contebt-right-border px-md-5 px-sm-5 px-2 col-md-8 col-sm-6'
                      >
                        <div className='mt-md-3 d-flex align-items-center'>
                          <img
                            src={Melbourne_Knight}
                            alt='team_logo'
                            className=''
                          />
                          <span className='ms-3'>Melbourne Knight </span>
                          <span className='ms-auto fw-bold'>3</span>
                        </div>

                        <div className='mt-3 d-flex align-items-center'>
                          <img
                            src={Sydney_thunder}
                            alt='team_logo'
                            className=''
                          />
                          <span className='ms-3'>Sydney thunder </span>
                          <span className='ms-auto fw-bold'>1</span>
                        </div>
                      </Col>

                      <Col
                        xs={5}
                        className='match_schedule d-flex flex-column justify-content-center ps-md-3 col-md-4 col-sm-6match_schedule d-flex flex-column justify-content-center ps-md-3 col-md-4 col-sm-6'
                      >
                        <div className='d-flex align-items-center'>
                          <Calander />
                          <span className='ms-2'>11/04/2024</span>
                        </div>
                        <div className='d-flex align-items-center  my-3'>
                          <Clock />
                          <span className='ms-2'>5:00PM</span>
                        </div>
                        <div className='d-flex align-items-center'>
                          <Location />
                          <span className='ms-2'>
                            Sydney Ground Australia
                          </span>
                        </div>
                      </Col>
                    </Row>
                  </Tab.Pane> */}
                              </Tab.Content>
                            </Tab.Container>
                          </Card.Body>
                        </Card>
                      </Col>
                    </Row>
                  </>
                ))
              ) : game === 'bowling' ? (
                latestMatch.map((match, index) => (
                  <>
                    <Row className='mb-5'>
                      <Col>
                        <Card
                          className='rounded-4 overflow-hidden complete-nav-card border-0'
                          style={CompleteMatchStyle}
                        >
                          <Card.Body className='p-0'>
                            <Row className="text-white mb-5">
                              <Col sm={4} xl={4} md={4}>
                                <p className="nav-active-tab align-items-center text-center border-radiusrb20px fw-bold text-white fs-5 py-2 " style={{ background: 'red', width: '79%' }}><span className="text-center w-100 davidcup-span">{replaceUnderscoreWithSpace(match.round)}</span></p>
                              </Col>

                            </Row>

                            <Row className='text-white'>

                              <CCol xl={9} xs={8} className='' >
                                <div className='' style={{ maxHeight: '400px' }}>
                                  <CRow className='custom-scrollbar'>
                                    {
                                      match.players && match.players.length > 0 && match.players.map((player, playerIndex) => {
                                        const playerDetails = match.player_details.find(
                                          details => details._id === player._id
                                        );

                                        if (!playerDetails) return null;

                                        return (
                                          <CCol xl={6} md={6} className='mb-3' key={playerIndex}>
                                            <div className='d-flex justify-content-center align-items-center plyr_row_latest_match_run'>
                                              <div
                                                style={{
                                                  backgroundImage: `url(${playerDetails.profile_image ? IMAGE_URL + "user/" + playerDetails.profile_image : ''})`
                                                }}
                                                className='scorer-img me-3  scorer_img_for_ltest_match'
                                              ></div>
                                              <div className='player-name me-5 text-start plyr_info_latest_match'>
                                                {/* name div */}
                                                {match.rank_1 === playerDetails._id ? (
                                                  <span>
                                                    <img src={golden} className='icons' alt='Golden Trophy' style={{ height: '20px' }} />
                                                  </span>
                                                ) : match.rank_2 === playerDetails._id ? (
                                                  <span>
                                                    <img src={silver} className='icons' alt='Silver Trophy' style={{ height: '20px' }} />
                                                  </span>
                                                ) : match.rank_3 === playerDetails._id && match.rank_3 != null ? (
                                                  <span>
                                                    <img src={bronze} className='icons' alt='Bronze Trophy' style={{ height: '20px' }} />
                                                  </span>
                                                ) : null}
                                                <h6 className='mb-0'>{playerDetails.fname + ' ' + playerDetails.lname}</h6>
                                                <p className="m-0 p-0 teamname_latest_match_run" style={{ color: '#2ed5d5' }}>{
                                                formatTitle(extractdomain(playerDetails.corporate_email, '@', '.'))
                                                }</p>
                                              </div>
                                              <div className='player-score'>
                                                <span className='text-white fw-bold fs-2'>{playerScore(match.players, player._id).points}</span>
                                              </div>
                                            </div>
                                          </CCol>
                                        );
                                      })
                                    }



                                  </CRow>
                                </div>
                                {/* <div className='d-flex align-items-center justify-content-around'>
                      <div className='w-100 ' >
                          {match.player_details.map((player, playerIndex) => (
                          <div className='d-flex justify-content-center align-items-center'>
                                <div key={playerIndex} className='player-container'>
                                  <div
                                    style={{
                                      backgroundImage: `url(${player.profile_image ? IMAGE_URL + "user/" + player.profile_image : ''})`,
                                      backgroundPosition: 'center',
                                      width: '80px',
                                      height: '80px',
                                      backgroundSize: 'cover', // Added to ensure the image covers the div
                                    }}
                                    className='scorer-img'
                                  ></div>

                                  <div className='player-name'>
                                    
                                    {player.fname}
                                  </div>
                                  <div className='player-score'>
                                    <span className='text-white'>45</span>
                                  </div>
                                </div>
                          </div>
                          ))}

                      </div>

                      <div  className='w-100 second-part'>
                    <h1 className='text-white '>Hello</h1>
                        
                      </div>
                  </div> */}
                              </CCol>
                              <CCol xl={3} xs={4} >
                                <div className='d-flex flex-column mt-5 gap-2 mt-0'>
                                  <div className=''>
                                    <Calander />
                                    <span className="ms-2 plyr_schdual_icon_info">{match.match_date != null ? newFormatdate(match.match_date, 0, 0, 0, 1) : 'N/A'}</span>
                                  </div>
                                  <div className='match_schedule my-2'>
                                    <span className="match_schedule" ><Clock /></span>
                                    <span className="ms-2 plyr_schdual_icon_info">{match.match_date != null ? newFormatdate(match.match_date, 0, 1) : 'N/A'}</span>
                                  </div>
                                  <div className='d-flex'>
                                    <div className="match_schedule"> <Location /> </div>
                                    <span className='ms-2 plyr_schdual_icon_info'>
                                      Strike Bowling QV
                                    </span>
                                  </div>
                                </div>

                              </CCol>
                            </Row>

                          </Card.Body>
                        </Card>
                      </Col>
                    </Row>
                  </>
                ))

              ) : (
                latestMatch.map((match, index) => (
                  <Row className='mb-5'>
                    <Col>
                      <Card
                        className='rounded-4 overflow-hidden complete-nav-card border-0'
                        style={CompleteMatchStyle}
                      >
                        <Card.Body className='p-0'>
                          <Row className="text-white mb-5">
                            <Col sm={4} xl={4} md={4}>
                              <p className="nav-active-tab align-items-center text-center border-radiusrb20px fw-bold text-white fs-5 py-2 "
                                style={{ background: 'red', width: '79%' }}>
                                <span className="text-center w-100 davidcup-span">{replaceUnderscoreWithSpace(match.round)}</span></p>
                            </Col>

                          </Row>

                          <Row className='text-white'>
                            <CCol xl={9} xs={8} className='' >
                              <div className='' style={{ maxHeight: '400px' }}>
                                <CRow className='custom-scrollbar'>

                                  {match.players && match.players.length > 0 && match.players.map((player, playerIndex) => {
                                    const playerDetails = match.player_details.find(
                                      details => details._id === player._id
                                    );

                                    if (!playerDetails) return null;

                                    return (
                                      <CCol xl={6} className='mb-4' key={playerIndex}>
                                        <div className='d-flex justify-content-center align-items-center plyr_row_latest_match_run '>
                                          <div
                                            style={{
                                              backgroundImage: `url(${playerDetails.profile_image ? IMAGE_URL + "user/" + playerDetails.profile_image : ''})`,
                                            }}
                                            className='scorer-img me-3 scorer_img_for_ltest_match'
                                          >
                                          </div>
                                          <div className='player-name me-5 text-start plyr_info_latest_match'>
                                            {/* name div */}
                                            {match.rank_1 === playerDetails._id ? (
                                              <span>
                                                <img src={golden} className='icons' alt='Golden Trophy' style={{ height: '20px' }} />
                                              </span>
                                            ) : match.rank_2 === playerDetails._id ? (
                                              <span>
                                                <img src={silver} className='icons' alt='Silver Trophy' style={{ height: '20px' }} />
                                              </span>
                                            ) : match.rank_3 === playerDetails._id && match.rank_3 != null ? (
                                              <span>
                                                <img src={bronze} className='icons' alt='Bronze Trophy' style={{ height: '20px' }} />
                                              </span>
                                            ) : null}
                                            <h6 className=' username_latest_match_run mb-0'>{playerDetails.fname + ' ' + playerDetails.lname}</h6>
                                            <div className="m-o p-0 teamname_latest_match_run" style={{ color: '#2ed5d5', textAlign: "start" }}>{
                                              formatTitle(

                                                extractdomain(playerDetails.corporate_email, '@', '.')
                                              )
                                            }</div>
                                          </div>
                                          <div className='player-score '>
                                            <span className='text-white fw-bold fs-2 plyr_score_latest_match'>
                                              {format_2k_run_Time_exact(
                                                playerScore(match.players, player._id).minutes, playerScore(match.players, player._id).second, playerScore(match.players, player._id).millisecond
                                              )
                                              }
                                            </span>
                                          </div>
                                        </div>
                                      </CCol>
                                    );
                                  })
                                  }


                                </CRow>
                              </div>
                              {/* <div className='d-flex align-items-center justify-content-around'>
                      <div className='w-100 ' >
                          {match.player_details.map((player, playerIndex) => (
                          <div className='d-flex justify-content-center align-items-center'>
                                <div key={playerIndex} className='player-container'>
                                  <div
                                    style={{
                                      backgroundImage: `url(${player.profile_image ? IMAGE_URL + "user/" + player.profile_image : ''})`,
                                      backgroundPosition: 'center',
                                      width: '80px',
                                      height: '80px',
                                      backgroundSize: 'cover', // Added to ensure the image covers the div
                                    }}
                                    className='scorer-img'
                                  ></div>

                                  <div className='player-name'>
                                    
                                    {player.fname}
                                  </div>
                                  <div className='player-score'>
                                    <span className='text-white'>45</span>
                                  </div>
                                </div>
                          </div>
                          ))}

                      </div>

                      <div  className='w-100 second-part'>
                    <h1 className='text-white '>Hello</h1>
                        
                      </div>
                  </div> */}
                            </CCol>
                            <CCol xl={3} xs={4} >
                              <div className='d-flex flex-column mt-5  gap-2 mt-0'>
                                <div className=''>
                                  <Calander />
                                  <span className="ms-2 plyr_schdual_icon_info">{match.match_date != null ? newFormatdate(match.match_date, 0, 0, 0, 1) : 'N/A'}</span>
                                </div>
                                <div className="match_schedule my-2">
                                  <span className="match_schedule" ><Clock /></span>
                                  <span className="ms-2 plyr_schdual_icon_info">{match.match_date != null ? newFormatdate(match.match_date, 0, 1) : 'N/A'}</span>
                                </div>
                                <div className='d-flex'>
                                  <div className="match_schedule"> <Location /> </div>
                                  <span className='ms-2 plyr_schdual_icon_info'>
                                    State Sports Centres - Lakeside Stadium </span>
                                </div>
                              </div>

                            </CCol>
                          </Row>

                        </Card.Body>
                      </Card>
                    </Col>
                  </Row>
                ))

              )


            ) :
              (
                waitListGame.badminton == true && game == 'Badminton' ? (
                  <>
                    {/* <div className=''>
                      <img src={badw} className='waiting_tournament_join_main'></img>
                      <div className='d-flex flex-column align-items-center span_btn_main_div'>

                        <div className='mb-4'>
                            <span className='text_join_tournament'>
                              {dynamicHeading.waitlist_message
                                ? dynamicHeading.waitlist_message.value
                                : 'You have not enrolled for this sport'}
                            </span>
                                </div>
                            <button className='btn_join_tournament'
                              onClick={() => waitListExitAPI()}>
                              Exit Waitlist
                            </button>


                      </div>
                    </div> */}
                    <div className='waiting_tournament_join_main' style={{ backgroundImage: `url(${badw})` }}>
                      <span className='text_join_tournament'>
                        {dynamicHeading.waitlist_message  
                          ? dynamicHeading.waitlist_message.value
                          : 'You have not enrolled for this sport'}
                      </span>
                      <button className='btn_join_tournament'
                        onClick={() => waitListExitAPI()}>
                        Exit Waitlist
                      </button>
                    </div>
                  </>
                ) : waitListGame.table_tenis == true && game == 'TableTennis' ? (
                  <>
                    <div className='waiting_tournament_join_main' style={{
                      backgroundImage: `url(${ttw})`
                      ,
                      backgroundPosition: 'top'
                    }}>
                      <span className='text_join_tournament'>
                        {dynamicHeading.waitlist_message
                          ? dynamicHeading.waitlist_message.value
                          : 'You have not enrolled for this sport'}
                      </span>
                      <button className='btn_join_tournament'
                        onClick={() => waitListExitAPI()}>
                        Exit Waitlist
                      </button>
                    </div>
                  </>
                ) : waitListGame.bowling == true && game == 'bowling' ? (
                  <>
                    < div className='waiting_tournament_join_main' style={{ backgroundImage: `url(${boww})`
                  
                  , backgroundPosition: 'center 15%' 
                  }}>
                      <span className='text_join_tournament'>
                        {dynamicHeading.waitlist_message
                          ? dynamicHeading.waitlist_message.value
                          : 'You have not enrolled for this sport'}
                      </span>
                      <button className='btn_join_tournament'
                        onClick={() => waitListExitAPI()}>
                        Exit Waitlist
                      </button>
                    </div>
                  </>
                ) : waitListGame.twok_run == true && game == '2k_run' ? (
                  <>
                    < div className='waiting_tournament_join_main' style={{ backgroundImage: `url(${twokw})` }}>
                      <span className='text_join_tournament'>
                        {dynamicHeading.waitlist_message
                          ? dynamicHeading.waitlist_message.value
                          : 'You have not enrolled for this sport'}
                      </span>
                      <button className='btn_join_tournament'
                        onClick={() => waitListExitAPI()}>
                        Exit Waitlist
                      </button>
                    </div>
                  </>
                )
                  : enrolledSport.badminton == false && getGame() == 'Badminton' ? (
                    <div className='tournament_join_main' style={{ backgroundImage: `url(${badw})` }}>
                      <span className='text_join_tournament'>
                        {dynamicHeading.not_enrolled_tttle
                          ? dynamicHeading.not_enrolled_tttle.value
                          : 'You have not enrolled for this sport'}
                      </span>
                      {
                        Joinbutton ? (
                          <button type="button" onClick={() => navigate('/select-sport')}
                            className="btn_join_tournament" data-mdb-ripple-init>
                            Join Tournament
                          </button>
                        ) : null
                      }
                    </div>
                  ) : enrolledSport.table_tenis == false && getGame() == 'TableTennis' ? (
                    <div className='tournament_join_main'
                      //  style={{backgroundImage:`url(${ttw})`}}
                      style={{
                        backgroundImage: `url(${ttw})`,
                        backgroundPosition: 'top'
                      }}>
                      <span className='text_join_tournament'>
                        {dynamicHeading.not_enrolled_tttle
                          ? dynamicHeading.not_enrolled_tttle.value
                          : 'You have not enrolled for this sport'}
                      </span>
                      {
                        Joinbutton ? (
                          <button type="button" onClick={() => navigate('/select-sport')}
                            className="btn_join_tournament" data-mdb-ripple-init>
                            Join Tournament
                          </button>
                        ) : null
                      }
                    </div>
                  ) : enrolledSport.bowling == false && getGame() == 'bowling' ? (
                    <div className='tournament_join_main' style={{ backgroundImage: `url(${boww})`, backgroundPosition: 'center 15%' }}>
                      <span className='text_join_tournament'>
                        {dynamicHeading.not_enrolled_tttle
                          ? dynamicHeading.not_enrolled_tttle.value
                          : 'You have not enrolled for this sport'}
                      </span>
                      {
                        Joinbutton ? (
                          <button type="button" onClick={() => navigate('/select-sport')}
                            className="btn_join_tournament" data-mdb-ripple-init>
                            Join Tournament
                          </button>
                        ) : null
                      }
                    </div>
                    // </div>


                  ) : enrolledSport.twok_run == false && getGame() == '2k_run' ? (
                    <div className='tournament_join_main' style={{ backgroundImage: `url(${twokw})` }}>
                      <span className='text_join_tournament'>
                        {dynamicHeading.not_enrolled_tttle
                          ? dynamicHeading.not_enrolled_tttle.value
                          : 'You have not enrolled for this sport'}
                      </span>
                      {
                        Joinbutton ? (
                          <button type="button" onClick={() => navigate('/select-sport')}
                            className="btn_join_tournament" data-mdb-ripple-init>
                            Join Tournament
                          </button>
                        ) : null
                      }
                    </div>
                  ) :
                    <>
                      <CCard
                        style={{
                          position: 'relative',
                          background: '#131313',
                          borderRadius: '15px'
                        }}
                      >
                        <div
                          className='card-background'
                        // style={{ backgroundImage: `url(${cardBg})` }}
                        />
                        <CCardBody
                          className='d-flex justify-content-center align-items-center'
                          style={{ padding: '0px', color: '#fff', height: '200px' }}
                        >
                          <div className='no_data_img_main'>
                            {/* <div
                              style={{
                                backgroundImage: `url(${notFound})`,
                                border: 'none'
                              }}
                              className='bg-image-container2 '
                            ></div> */}
                            <span
                              style={{
                                color: 'white',
                                fontSize: '20px',
                                fontWeight: '700'
                              }}
                            >
                              No Latest Match found
                            </span>
                          </div>
                        </CCardBody>
                      </CCard>
                    </>
              )}
          </>
        )

      }


    </div>
  )
}
export default React.memo(LatestMatch)
